import React, { useEffect, useState } from 'react'
import sliders from '../../../img/slidersSVG.svg'
import codeIcon from '../../../img/xmark.svg'
import ViewApiCall from '../../../ViewApiCall'
import useStore from '../../BusinessStore/Store'
import Modal from '../modal/ExpandedModal'
import styles from './styles.module.css'

const stylesFilters = {
  divStyles: {
    width: '1.5px',
    height: '23.5px',
    backgroundColor: '#ABABAB',
    margin: '0px 12.5px 2.5px 12.5px',
    display: 'block',
    alignSelf: 'end',
    paddingBottom: '5px'
  }
}

function ExpandedFilters () {
  const {
    isQueryLoading,
    queryStore,
    resetStore,
    name,
    city,
    primaryCategories,
    rawCategory,
    address,
    state,
    postalCode,
    country,
    recordRecency,
    featureKeyword,
    description,
    requiredFields,
    reviews,
    menus,
    geoLocation,
    reviewsRangeQuery,
    reviewsByDate
  } = useStore()

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [usedFiltersCount, setUsedFiltersCount] = useState(0)
  const dataType = 'business'

  useEffect(() => {
    const countUsedFilters = () => {
      let count = 0
      if (name) count++
      if (country) count++
      if (rawCategory) count++
      if (primaryCategories.length > 0 && !primaryCategories.includes('Any'))
        count++
      if (address) count++
      if (city) count++
      if (state) count++
      if (postalCode) count++
      if (recordRecency?.dateAdded) count++
      if (recordRecency?.dateUpdated) count++
      if (reviewsByDate?.start) count++
      if (reviewsByDate?.end) count++
      if (featureKeyword?.key || featureKeyword?.value) {
        count++
      }
      if (description?.value) {
        count++
      }
      if (reviews?.value) {
        count++
      }
      if (menus?.value) {
        count++
      }
      if (menus?.geoLocation) {
        count++
      }
      if (reviewsRangeQuery?.min || reviewsRangeQuery?.max) {
        count++
      }
      if (requiredFields.length > 0) count++

      setUsedFiltersCount(count)
    }

    countUsedFilters()
  }, [
    name,
    city,
    primaryCategories,
    address,
    state,
    postalCode,
    country,
    rawCategory,
    recordRecency,
    featureKeyword,
    description,
    requiredFields,
    reviews,
    menus,
    geoLocation,
    reviewsRangeQuery,
    reviewsByDate
  ])

  const toggleModal = () => {
    if (!isQueryLoading) {
      setIsModalVisible(!isModalVisible)
    }
  }

  const cursorStyle = isQueryLoading
    ? { opacity: '0.5', cursor: 'not-allowed' }
    : { cursor: 'pointer' }

  const handleClearFilters = () => {
    if (queryStore) {
      resetStore()
    }
  }

  const isDisabled = !queryStore || isQueryLoading

  return (
    <div className={styles.filterContainer}>
      <div
        onClick={isQueryLoading ? null : toggleModal}
        style={{
          display: 'flex',
          paddingBottom: '5px',
          alignSelf: 'flex-end',
          cursor: 'pointer'
        }}
      >
        <span
          onClick={isQueryLoading ? null : toggleModal}
          className={`${styles.filterLabel} ${styles.cursorStyle}`}
          style={cursorStyle}
        >
          All filters
        </span>

        <img
          src={sliders}
          alt='sliders'
          className={`${styles.filterIcon} ${styles.cursorStyle}`}
          style={cursorStyle}
          onClick={isQueryLoading ? null : toggleModal}
        />
        <span
          className={`${styles.filterLabel} ${styles.cursorStyle}`}
          style={cursorStyle}
          onClick={isQueryLoading ? null : toggleModal}
        >
          ({usedFiltersCount} Used)
        </span>
      </div>

      {isModalVisible && <Modal onClose={() => setIsModalVisible(false)} />}
      <div style={stylesFilters.divStyles}></div>

      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          paddingBottom: '5px'
        }}
      >
        <span
          onClick={queryStore === '' ? undefined : handleClearFilters}
          className={styles.clearFiltersSearch}
          style={{
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.5 : 1
          }}
        >
          Clear filters
        </span>
        <img
          onClick={queryStore === '' ? undefined : handleClearFilters}
          src={codeIcon}
          alt='codeIcon'
          style={{
            height: '14px',
            marginBottom: '1.5px',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.5 : 1
          }}
        />
      </div>

      <div style={stylesFilters.divStyles}></div>

      <ViewApiCall dataType={dataType} />
    </div>
  )
}

export default ExpandedFilters
